import { ApiResponse } from 'app/types-shared';
import { RemoteData, RemoteAdminData } from 'app/infrastructure/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';

type CodeWireFormat = {
  rootCodes: CodetableWireFormat[]
};

export const endpoint = {
  caseTypes: 'case/options/casetypes/editable',
  connectedCaseTypes: (draftId) => `case/draft/${draftId}/options/casetypes/editable`,
  changeCaseTypes: (draftId, casetypeId) => `case/draft/${draftId}/casetype/${casetypeId}`,
  codetableAdministrationList: 'optionsCollection/hierarchy',
  dashboards: 'dashboard',
  companyReports: 'report/specialReportTypes',
  savedReports: 'user/current/options/savedFavourites'
};

export const api = {
  caseTypes: async (): Promise<CodetableWireFormat[]> => {
    const response = await new RemoteData(endpoint.caseTypes)
      .resource<ApiResponse<CodetableWireFormat[]>>()
      .all();

    return response.data;
  },

  connectedCaseTypes: async (draftId, connectionTypeId): Promise<CodetableWireFormat[]> => {
    const response = await new RemoteData(endpoint.connectedCaseTypes(draftId))
      .resource<ApiResponse<CodetableWireFormat[]>>()
      .filter({ connectionTypeId })
      .all();

    return response.data;
  },

  dashboards: async (): Promise<CodeWireFormat> => {
    const response = await new RemoteData(endpoint.dashboards)
      .resource<ApiResponse<CodeWireFormat>>()
      .all();

    return response.data;
  },

  savedReports: async (): Promise<CodeWireFormat> => {
    const response = await new RemoteData(endpoint.savedReports)
      .resource<ApiResponse<CodeWireFormat>>()
      .all();

    return response.data;
  },

  companyReports: async (): Promise<CodeWireFormat> => {
    const response = await new RemoteData(endpoint.companyReports)
      .resource<ApiResponse<CodeWireFormat>>()
      .all();

    return response.data;
  },

  codetableAdministrationList: async (): Promise<CodeWireFormat> => {
    const response = await new RemoteAdminData(endpoint.codetableAdministrationList)
      .resource<ApiResponse<CodeWireFormat>>()
      .all();

    return response.data;
  }
};
